<template>
    <div>
        <router-view />
        <Layout :menuList="menuList" :active="active"></Layout>
    </div>
</template>

<script>
    import Layout from '@/WechatComponents/Layout.vue';

    export default {
        components: {
            Layout
        },
        data() {
            return {
                menuList: [],
                active : 0,
                path:'',
            }
        },
        created() { 
            this.path = this.$route.path;
            const { path } = this;
            console.log(path);
            if (path == '/wechat/revenue' || path == '/wechat/device') {
                this.menuList = [
                    { name: '带宽详情', icon: 'chart-trending-o', url: '/wechat/revenue' },
                    { name: '运行状况', icon: 'bulb-o', url: '/wechat/device' },
                ]
            } else if (path == '/wechat' || path == '/wechat/unbind') {
                this.menuList = [
                    { name: '账号绑定', icon: 'edit', url: '/wechat' },
                    { name: '账号列表', icon: 'orders-o', url: '/wechat/unbind' },
                ]
            } else if (path == '/wechat/withdrawal' || path == '/wechat/exchangeList') {
                this.menuList = [
                    { name: '提现', icon: 'cash-back-record', url: '/wechat/withdrawal' },
                    { name: '兑换JD卡', icon: 'ecard-pay', url: '/wechat/exchangeList' }, 
                ]
            }
        },
        watch: {
            path(val) {
                console.log(val);
                if(val == '/wechat/exchangeList' || val == '/wechat/unbind' || val == '/wechat/device') {
                    this.active = 1;
                } else {
                    this.active = 0;
                }
            }
        }
    }

</script>

<style>

</style>